import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
const MESSAGES = ['Sofía G. de Córdoba Capital acaba de comprar el Sistema BIO-SYNC ⚡', 'Martín R. de Rosario, Santa Fe se sumó a BIO-SYNC hace 5 min ✅', 'Lucía B. de Ramos Mejía, Buenos Aires descargó su pack ahora 🔥', 'Facundo S. de Mendoza Ciudad empezó su proceso hoy 🚀', 'Mariana T. de San Miguel de Tucumán protegió a su adolescente ✅'];
const VISIBLE_MS = 4000;
const INTERVAL_MS = 12000;
export const SocialProofPopup = () => {
  const [visible, setVisible] = useState(false);
  const [index, setIndex] = useState(0);
  useEffect(() => {
    let hideTimer: ReturnType<typeof setTimeout>;
    // First popup after 4s, then every 12s
    const showPopup = () => {
      setVisible(true);
      hideTimer = setTimeout(() => setVisible(false), VISIBLE_MS);
    };
    const firstShow = setTimeout(showPopup, 4000);
    const cycle = setInterval(() => {
      setIndex(i => (i + 1) % MESSAGES.length);
      showPopup();
    }, INTERVAL_MS);
    return () => {
      clearTimeout(firstShow);
      clearTimeout(hideTimer);
      clearInterval(cycle);
    };
  }, []);
  return <div className="fixed z-50 pointer-events-none top-4 left-1/2 -translate-x-1/2 sm:left-auto sm:translate-x-0 sm:right-5 sm:top-5 w-[92%] max-w-xs sm:max-w-sm" data-id="element-298">
      <AnimatePresence mode="wait" data-id="element-299">
        {visible && <motion.div key={index} initial={{
        opacity: 0,
        y: -16,
        scale: 0.95
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: -8,
        scale: 0.97
      }} transition={{
        duration: 0.4,
        ease: 'easeOut'
      }} className="bg-white rounded-[10px] shadow-[0_8px_24px_rgba(0,0,0,0.12)] border border-gray-100 p-3 flex items-center gap-3 pointer-events-auto" role="status" aria-live="polite" data-id="element-300">
            <span className="relative flex h-2.5 w-2.5 shrink-0" data-id="element-301">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-biosync opacity-60" data-id="element-302"></span>
              <span className="relative inline-flex rounded-full h-2.5 w-2.5 bg-biosync" data-id="element-303"></span>
            </span>
            <p className="text-biosync-text text-[12px] leading-snug" data-id="element-304">
              {MESSAGES[index]}
            </p>
          </motion.div>}
      </AnimatePresence>
    </div>;
};